module.exports = __webpack_public_path__ + "img/bgcenter.a0e28b17.png";